module.exports = __webpack_public_path__ + "static/media/workshop_upcoming_emptystate.2960ada2.svg";